// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/UQM-3DOMenuLabels.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/UQM-CommanderFont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/UQM-TinyFont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "UQM-3DO";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
  font-family: "UQM-CommanderFont";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
  font-family: "UQM-TinyFont";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

body {
    width: 100%;
    height: 100%;
    background-color: #000;
    color: #fff;
    margin: 0px;
    padding: 0;
    overflow: hidden;
    font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}

.property-name {
    font-family: "UQM-TinyFont";
}

li.title {
  font-family: "UQM-TinyFont";
}

.close-button
{
  font-family: "UQM-TinyFont";
}

a
{
  color: #ff4800;
}

#brandTag
{
	position: fixed;
	display: block;
	top: 0px;
	left: 30px;
	color: white;
	background-color: rgba(0, 0, 0, 0.8);
	z-index: 1000;
	text-align: center;
	padding: 12px 12px 12px 12px;
	font-size: 18px;
	font-family: "UQM-3DO",  Helvetica, sans-serif;
	transition-property: color, background-color, padding;
	transition-duration: 0.3s;
}

#creditsBox {
  position: fixed;
  z-index: 1000;
  bottom: 0px;
  left: 20px;
  color: #FFFFFF;
  background-color: rgba(0, 0, 0, 0.8);
  width: 30%;
}

#brandTagImage
{
  vertical-align: middle;
  padding-right: 12px;
}

@media (width < 600px) {

}

@media screen and (max-width: 600px) {
  #brandTag
  {
  	display: none;
  }
  #infoBoxHolder
  {
  	display: none;
  }
}

@media screen and (min-width: 600px) {
  #infoBoxHolderMobile {
    display: none;
  }
  #newPlanetButtonHolder {
    display: none;
  }
}

#brandTag:hover
{
	color: black;
	background-color: white;
	padding: 24px 12px 12px 12px;
}

#infoBoxHolder {
  position: absolute;
  z-index: 1000;
  top: 0px;
  right: 20px;
  color: #FFFFFF;
  background-color: rgba(0, 0, 0, 0.8);
  width: 245px;
}

#infoBox {
  padding: 12px 12px 12px 12px;
  font-size: 14px;
	font-family: "Helvetica-Light", sans-serif;
  line-height: 18px;
}

#planetName {
  font-size: 24px;
  line-height: 28px;
  font-family: "UQM-CommanderFont";
}

#instructions {
  font-size: 10px;
}

#infoBoxHolderMobile {
  position: absolute;
  z-index: 1000;
  top: 0px;
  width: 100%;

}

#infoBoxMobile {

  margin: 0 auto;

  width: 245px;
  color: #FFFFFF;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 12px 12px 12px 12px;
  font-size: 14px;
	font-family: "Helvetica-Light", sans-serif;
  line-height: 18px;
  text-align: center;
}

#planetNameMobile {
  font-size: 24px;
  line-height: 28px;
  font-family: "UQM-CommanderFont";
}


#newPlanetButtonHolder {
  position: absolute;
  z-index: 1000;
  bottom: 0px;
  width: 100%;
}

#newPlanetButton {
  margin: 0 auto;

  width: 145px;
  color: #FFFFFF;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 12px 12px 12px 12px;
  font-size: 18px;
  font-family: "UQM-TinyFont", "Helvetica-Light", sans-serif;
  line-height: 18px;
  text-align: center;
}

#line {
  background-color: rgba(255, 255, 255, 0.2);
  width: 100%;
  height: 1px;
}


#biomeCanvas {
  position: absolute;
  z-index: 1000;
  bottom: 0px;
  right: 0px;
}

#nebulaeCanvas {
  position: absolute;
  z-index: 1000;
  bottom: 0px;
  left: 0px;
}

#sunCanvas {
  position: absolute;
  z-index: 1000;
  bottom: 0px;
  right: 0px;
}

/* Position the button VR on the bottom of the page. */
#ui {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-family: 'Karla', sans-serif;
    z-index: 1;
}

a#magic-window {
    display: block;
    color: white;
    margin-top: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,+DAA6D;AAC/D;;AAEA;EACE,gCAAgC;EAChC,+DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,+DAAwD;AAC1D;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,2DAA2D;AAC/D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;CAEC,eAAe;CACf,cAAc;CACd,QAAQ;CACR,UAAU;CACV,YAAY;CACZ,oCAAoC;CACpC,aAAa;CACb,kBAAkB;CAClB,4BAA4B;CAC5B,eAAe;CACf,8CAA8C;CAC9C,qDAAqD;CACrD,yBAAyB;AAC1B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,UAAU;EACV,cAAc;EACd,oCAAoC;EACpC,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;AAEA;;AAEA;EACE;;GAEC,aAAa;EACd;EACA;;GAEC,aAAa;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA;;CAEC,YAAY;CACZ,uBAAuB;CACvB,4BAA4B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,WAAW;EACX,cAAc;EACd,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,eAAe;CAChB,0CAA0C;EACzC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,WAAW;;AAEb;;AAEA;;EAEE,cAAc;;EAEd,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;CAChB,0CAA0C;EACzC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;;EAEd,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;EACf,0DAA0D;EAC1D,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA,sDAAsD;AACtD;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;AACnB","sourcesContent":["@font-face {\n  font-family: \"UQM-3DO\";\n  src: url('../fonts/UQM-3DOMenuLabels.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: \"UQM-CommanderFont\";\n  src: url('../fonts/UQM-CommanderFont.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: \"UQM-TinyFont\";\n  src: url('../fonts/UQM-TinyFont.ttf') format('truetype');\n}\n\nbody {\n    width: 100%;\n    height: 100%;\n    background-color: #000;\n    color: #fff;\n    margin: 0px;\n    padding: 0;\n    overflow: hidden;\n    font-family: Arial, \"Helvetica Neue\", Helvetica, sans-serif;\n}\n\n.property-name {\n    font-family: \"UQM-TinyFont\";\n}\n\nli.title {\n  font-family: \"UQM-TinyFont\";\n}\n\n.close-button\n{\n  font-family: \"UQM-TinyFont\";\n}\n\na\n{\n  color: #ff4800;\n}\n\n#brandTag\n{\n\tposition: fixed;\n\tdisplay: block;\n\ttop: 0px;\n\tleft: 30px;\n\tcolor: white;\n\tbackground-color: rgba(0, 0, 0, 0.8);\n\tz-index: 1000;\n\ttext-align: center;\n\tpadding: 12px 12px 12px 12px;\n\tfont-size: 18px;\n\tfont-family: \"UQM-3DO\",  Helvetica, sans-serif;\n\ttransition-property: color, background-color, padding;\n\ttransition-duration: 0.3s;\n}\n\n#creditsBox {\n  position: fixed;\n  z-index: 1000;\n  bottom: 0px;\n  left: 20px;\n  color: #FFFFFF;\n  background-color: rgba(0, 0, 0, 0.8);\n  width: 30%;\n}\n\n#brandTagImage\n{\n  vertical-align: middle;\n  padding-right: 12px;\n}\n\n@media (width < 600px) {\n\n}\n\n@media screen and (max-width: 600px) {\n  #brandTag\n  {\n  \tdisplay: none;\n  }\n  #infoBoxHolder\n  {\n  \tdisplay: none;\n  }\n}\n\n@media screen and (min-width: 600px) {\n  #infoBoxHolderMobile {\n    display: none;\n  }\n  #newPlanetButtonHolder {\n    display: none;\n  }\n}\n\n#brandTag:hover\n{\n\tcolor: black;\n\tbackground-color: white;\n\tpadding: 24px 12px 12px 12px;\n}\n\n#infoBoxHolder {\n  position: absolute;\n  z-index: 1000;\n  top: 0px;\n  right: 20px;\n  color: #FFFFFF;\n  background-color: rgba(0, 0, 0, 0.8);\n  width: 245px;\n}\n\n#infoBox {\n  padding: 12px 12px 12px 12px;\n  font-size: 14px;\n\tfont-family: \"Helvetica-Light\", sans-serif;\n  line-height: 18px;\n}\n\n#planetName {\n  font-size: 24px;\n  line-height: 28px;\n  font-family: \"UQM-CommanderFont\";\n}\n\n#instructions {\n  font-size: 10px;\n}\n\n#infoBoxHolderMobile {\n  position: absolute;\n  z-index: 1000;\n  top: 0px;\n  width: 100%;\n\n}\n\n#infoBoxMobile {\n\n  margin: 0 auto;\n\n  width: 245px;\n  color: #FFFFFF;\n  background-color: rgba(0, 0, 0, 0.8);\n  padding: 12px 12px 12px 12px;\n  font-size: 14px;\n\tfont-family: \"Helvetica-Light\", sans-serif;\n  line-height: 18px;\n  text-align: center;\n}\n\n#planetNameMobile {\n  font-size: 24px;\n  line-height: 28px;\n  font-family: \"UQM-CommanderFont\";\n}\n\n\n#newPlanetButtonHolder {\n  position: absolute;\n  z-index: 1000;\n  bottom: 0px;\n  width: 100%;\n}\n\n#newPlanetButton {\n  margin: 0 auto;\n\n  width: 145px;\n  color: #FFFFFF;\n  background-color: rgba(0, 0, 0, 0.8);\n  padding: 12px 12px 12px 12px;\n  font-size: 18px;\n  font-family: \"UQM-TinyFont\", \"Helvetica-Light\", sans-serif;\n  line-height: 18px;\n  text-align: center;\n}\n\n#line {\n  background-color: rgba(255, 255, 255, 0.2);\n  width: 100%;\n  height: 1px;\n}\n\n\n#biomeCanvas {\n  position: absolute;\n  z-index: 1000;\n  bottom: 0px;\n  right: 0px;\n}\n\n#nebulaeCanvas {\n  position: absolute;\n  z-index: 1000;\n  bottom: 0px;\n  left: 0px;\n}\n\n#sunCanvas {\n  position: absolute;\n  z-index: 1000;\n  bottom: 0px;\n  right: 0px;\n}\n\n/* Position the button VR on the bottom of the page. */\n#ui {\n    position: absolute;\n    bottom: 10px;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    font-family: 'Karla', sans-serif;\n    z-index: 1;\n}\n\na#magic-window {\n    display: block;\n    color: white;\n    margin-top: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
